import { LinkButton } from "@ui-kit/LinkButton/LinkButton";
import { FunctionComponent } from "react";

interface AuthLinkButtonProps {
  onPress: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label: string;
  disabled?: boolean;
}

export const AuthLinkButton: FunctionComponent<AuthLinkButtonProps> = ({
  onPress,
  label,
  disabled,
}) => {
  return (
    <LinkButton
      type="info"
      size="large"
      fullWidth={true}
      onPress={onPress}
      disabled={disabled}
      htmlType="button">
      {label}
    </LinkButton>
  );
};
